import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const cookieTexts = {
  en: {
    message: 'This website only uses strictly necessary cookies that do not require your consent. These cookies are essential for the website to function properly.',
    close: 'Got it',
  },
  sv: {
    message: 'Denna webbplats använder endast strikt nödvändiga cookies som inte kräver ditt samtycke. Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt.',
    close: 'Jag förstår',
  },
};

export const CookieBanner = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);
  const texts = cookieTexts[language] || cookieTexts.en;

  useEffect(() => {
    const dismissed = localStorage.getItem('insolvio-cookie-banner-dismissed');
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('insolvio-cookie-banner-dismissed', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4"
      style={{ 
        backgroundColor: '#ffffff', 
        borderTop: '1px solid #e5e5e5',
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.05)'
      }}
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left" style={{ color: '#6b6b6b', letterSpacing: '0.025em' }}>
          {texts.message}
        </p>
        <button
          onClick={handleClose}
          className="rounded-md px-4 py-2 text-sm font-medium transition-all duration-200 whitespace-nowrap"
          style={{ backgroundColor: '#1c8a56', color: '#ffffff' }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          data-testid="cookie-banner-close"
        >
          {texts.close}
        </button>
      </div>
    </div>
  );
};
